import { AgencyState } from '@/store/agency/AgencyStore';
import { AgencyProduct } from '@/types-agency';

export const agencyHasSomeProductCodes = (
  productCodes: Array<AgencyProduct['productCode']>,
  agency: AgencyState,
): boolean => {
  return (
    Array.isArray(agency.activeProducts) &&
    agency.activeProducts.some((product: AgencyProduct) =>
      productCodes.includes(product.productCode),
    )
  );
};

export const productCodeIncludes = (
  productCodeToFind: string,
  productCodesToSearchOn: Array<AgencyProduct['productCode']>,
): boolean => productCodesToSearchOn.includes(productCodeToFind);
